// extracted by mini-css-extract-plugin
export default {"root":"ShoesComponentTwo_root__UvRol","title":"ShoesComponentTwo_title__WJdCJ","flex":"ShoesComponentTwo_flex__foH2f","cards":"ShoesComponentTwo_cards__XhM0E"};